// extracted by mini-css-extract-plugin
export default {"box":"ul4sQPeyOE","visible":"sP7irI-vWJ","micro":"q5m0zJdkS6","inline":"qFdC-pyaOP","spinner":"-3bAGj8YhO","bar":"Qs5c7ccoXa","circle":"kkSjd3uP2I","rotate":"Nu0EVWAEe1","stop":"_9AXkjwAXAu","faded":"+b8jxDGDqI","message":"FKMHNFwIT2","center":"qDutkUGKvF","small":"kdTrRRtOoq"};
    if(module.hot) {
      // 1650537964537
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  